import { render, staticRenderFns } from "./EModalDuplicarAula.vue?vue&type=template&id=675ec89c&scoped=true"
import script from "./EModalDuplicarAula.vue?vue&type=script&lang=js"
export * from "./EModalDuplicarAula.vue?vue&type=script&lang=js"
import style0 from "./EModalDuplicarAula.vue?vue&type=style&index=0&id=675ec89c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ec89c",
  null
  
)

export default component.exports